"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateObjectProperties = exports.validateIsEmpty = exports.phoneFieldValidation = exports.lastNameFieldValidation = exports.fullNameFieldValidation = exports.firstNameFieldValidation = exports.fieldIsEmpty = exports.emailFieldValidation = exports.defaultFieldValidators = exports.basicValidation = void 0;
var _commonUtils = require("./commonUtils");
var _constants = require("../constants/constants");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var basicValidation = function basicValidation(referenceContainer) {
  var fieldsAreInvalid = (0, _commonUtils.classExists)(['payment-widget__checkout__fields__input__error']);
  var buttonIsDisabled = referenceContainer['paymentSubmitBtn'].hasAttribute('disabled');
  return !fieldsAreInvalid && !buttonIsDisabled;
};
exports.basicValidation = basicValidation;
var fieldIsEmpty = function fieldIsEmpty(errorMessage) {
  return function (value) {
    // check if this string is either falsy or made of nothing but spaces
    if (!value || !value.trim().length) {
      return errorMessage;
    }
    return null;
  };
};
exports.fieldIsEmpty = fieldIsEmpty;
var firstNameFieldValidation = function firstNameFieldValidation(block, value) {
  var firstNameLimit = block.firstNameLimit;
  if (value.length > firstNameLimit) {
    return block.isFirstNameMaxMessage;
  }
  if (_constants.EMOJI_REGEX.test(value) || !_constants.NAME_VALIDATION_REGEX.test(value)) {
    return block.isFirstNameInvalidMessage;
  }
  return null;
};
exports.firstNameFieldValidation = firstNameFieldValidation;
var lastNameFieldValidation = function lastNameFieldValidation(block, value) {
  var lastNameLimit = block.lastNameLimit;
  if (value.length > lastNameLimit) {
    return block.isLastNameMaxMessage;
  }
  if (_constants.EMOJI_REGEX.test(value) || !_constants.NAME_VALIDATION_REGEX.test(value)) {
    return block.isLastNameInvalidMessage;
  }
  return null;
};
exports.lastNameFieldValidation = lastNameFieldValidation;
var fullNameFieldValidation = function fullNameFieldValidation(block, value) {
  var fullNameLimit = block.fullNameLimit;
  if (value.length > fullNameLimit) {
    return block.isFullNameMaxMessage;
  }
  if (_constants.EMOJI_REGEX.test(value) || !_constants.NAME_VALIDATION_REGEX.test(value)) {
    return block.isFullNameInvalidMessage;
  }
  return null;
};
exports.fullNameFieldValidation = fullNameFieldValidation;
var emailFieldValidation = function emailFieldValidation(block, value) {
  var pattern = block.pattern || _constants.EMAIL_VALIDATION_REGEX;
  // Test against the regex pattern
  if (!pattern.test(value)) {
    return block.isInvalidMessage;
  }
  return null;
};
exports.emailFieldValidation = emailFieldValidation;
var phoneFieldValidation = function phoneFieldValidation(block, value) {
  var pattern = block.pattern || _constants.PHONE_NUMBER_VALIDATION_REGEX;
  // Test against the regex pattern
  if (!pattern.test(value)) {
    return block.isInvalidMessage;
  }
  return null;
};
exports.phoneFieldValidation = phoneFieldValidation;
var validateIsEmpty = function validateIsEmpty(errorMessages, value) {
  return fieldIsEmpty(errorMessages.isEmptyMessage)(value) || '';
};
exports.validateIsEmpty = validateIsEmpty;
var defaultFieldValidators = {
  firstNameField: function firstNameField(block, value) {
    return fieldIsEmpty(block.isFirstNameEmptyMessage)(value) || firstNameFieldValidation(block, value);
  },
  lastNameField: function lastNameField(block, value) {
    return fieldIsEmpty(block.isLastNameEmptyMessage)(value) || lastNameFieldValidation(block, value);
  },
  fullNameField: function fullNameField(block, value) {
    return fieldIsEmpty(block.isFullNameEmptyMessage)(value) || fullNameFieldValidation(block, value);
  },
  emailField: function emailField(block, value) {
    return fieldIsEmpty(block.isEmptyMessage)(value) || emailFieldValidation(block, value);
  },
  phoneField: function phoneField(block, value) {
    return fieldIsEmpty(block.isEmptyMessage)(value) || phoneFieldValidation(block, value);
  }
};

/**
 * 
 * @param {object} obj 
 * @param {array} validations 
 * @returns boolean
 */
exports.defaultFieldValidators = defaultFieldValidators;
var validateObjectProperties = function validateObjectProperties(obj, validations) {
  var validate = function validate(obj, validations, ind) {
    if (ind == validations.length) {
      return true;
    }
    if (_typeof(validations[ind]) === 'object') {
      return obj.hasOwnProperty(validations[ind].property) && validate(obj[validations[ind].property], validations[ind].validations, 0);
    }
    return obj.hasOwnProperty(validations[ind]) && validate(obj, validations, ind + 1);
  };
  return validate(obj, validations, 0);
};
exports.validateObjectProperties = validateObjectProperties;